import React, { Component } from 'react'
import { extendParentClass } from '../../../utils/classes'
import Item from './Item'

export class Features extends Component {
  baseClass = extendParentClass.bind(this)('features')

  items = [
    'Actionable Analytics',
    'Real-time Updates',
    'Monitor Engagement',
    'Import and Export',
  ]

  renderItems = () =>
    this.items.map((name, index) => (
      <Item key={index} parentClass={this.baseClass}>
        {name}
      </Item>
    ))

  render() {
    return <ul className={this.baseClass}>{this.renderItems()}</ul>
  }
}

export default Features
